import { useMemo } from "react";
import {
	Configure,
	InstantSearch,
	useCurrentRefinements,
	useHits,
} from "react-instantsearch-hooks-web";
import { searchClient } from "../algoliaClient";

const getRefinementValue = (items, attribute) => {
	const item = items.find(
		(i) => i.attribute.toLowerCase() === attribute.toLowerCase(),
	);
	return item?.refinements?.[0]?.value ?? null;
};

const RelatedProductsCarousel = ({ mainObjectIds, make, model, year }) => {
	const { hits } = useHits();

	const filtered = useMemo(
		() => hits.filter((h) => !mainObjectIds.has(h.objectID)).slice(0, 8),
		[hits, mainObjectIds],
	);

	if (filtered.length === 0) return null;

	return (
		<div className="py-6">
			<h2 className="anton text-xl mb-4">
				OTHER PRODUCTS YOU MIGHT BE INTERESTED IN FOR YOUR{" "}
				<span className="bg-[#dd2c2c] text-white px-2 py-1 rounded-sm inline-block">
					{year} {make ? `${make}` : ""} {model}
				</span>
			</h2>
			<div className="related-carousel">
				{filtered.map((hit) => (
					<a
						key={hit.objectID}
						href={hit.url}
						className="block flex-shrink-0 w-[320px] group"
						style={{ scrollSnapAlign: "start" }}
					>
						<div className="aspect-square overflow-hidden">
							{hit.photo ? (
								<img
									src={hit.photo}
									alt={hit.name}
									className="w-full h-full object-contain group-hover:scale-105 transition-transform"
									loading="lazy"
								/>
							) : (
								<div className="w-full h-full flex items-center justify-center text-gray-400">
									No Image
								</div>
							)}
						</div>
						<h3 className="anton text-[17px] mt-2 uppercase leading-tight">
							{hit.name}
						</h3>
						{hit.priceMin != null && (
							<p className="mt-1 mb-0 font-semibold">
								${Number(hit.priceMin).toLocaleString()}
							</p>
						)}
					</a>
				))}
			</div>
		</div>
	);
};

export const RelatedProducts = () => {
	const { items } = useCurrentRefinements();
	const { hits: mainHits } = useHits();

	const category = getRefinementValue(items, "categoryArray");
	const year = getRefinementValue(items, "Year");
	const model = getRefinementValue(items, "Model");
	const make = getRefinementValue(items, "Make");

	const shouldShow = Boolean(category && year && model);

	const mainObjectIds = useMemo(
		() => new Set(mainHits.map((h) => h.objectID)),
		[mainHits],
	);

	if (!shouldShow) return null;

	const filters = [
		`Year:"${year}"`,
		make && `Make:"${make}"`,
		`Model:"${model}"`,
		`NOT categoryArray:"${category}"`,
	]
		.filter(Boolean)
		.join(" AND ");

	return (
		<InstantSearch searchClient={searchClient} indexName="products">
			<Configure hitsPerPage={16} filters={filters} />
			<RelatedProductsCarousel
				mainObjectIds={mainObjectIds}
				make={make}
				model={model}
				year={year}
			/>
		</InstantSearch>
	);
};
